export const isPhone = checkMobile();
import { applySavedDarkMode } from './library';
/*
//======================================================================
//Courtesy of https://stackoverflow.com/a/9851769
// Opera 8.0+
export const isOpera = (!!window['opr'] && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
// Firefox 1.0+
export const isFirefox = typeof InstallTrigger !== 'undefined';
// Safari 3.0+ "[object HTMLElementConstructor]"
export const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
// Internet Explorer 6-11
export const isIE = /*@cc_on!@*/ /*false || !!document.documentMode;
// Edge 20+
export const isEdge = !isIE && !!window.StyleMedia;
// Chrome 1 - 79
export const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
// Edge (based on chromium) detection
export const isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
// Blink engine detection
export const isBlink = (isChrome || isOpera) && !!window.CSS;
//======================================================================*/
function checkMobile() {
    return false;
}
function collapseOnPhone() {
    if (isPhone) {
        var imgs = document.getElementsByClassName("deembed-media");
        while (imgs.length > 0) {
            let img = imgs[0];
            let par = img.parentNode;
            //console.log(img.src+" @ "+par.tagName);
            if (par.tagName == "VIDEO") {
                let put = document.createElement("div");
                put.innerHTML = '<a href = "' + img.src + '">' + img.src + "</a>";
                par.parentNode.replaceChild(put, par);
            }
            else {
                //par.replaceChild(put, img);
                if (par.className == "video") {
                    var url = img.src.replace("embed/", "watch?v=");
                    par.innerHTML = '<a href = "' + url + '">' + url + "</a>";
                }
                else if (par.className != "header-image")
                    par.innerHTML = img.src + "<br>";
                else
                    par.innerHTML = "";
            }
            console.log("Hiding media '" + img.src + "'");
        }
        var text = document.getElementsByClassName("textarea");
        for (var i = 0; i < text.length; i++) {
            text[i].style.width = "33%";
        }
        let header = document.createElement("div");
        header.innerHTML = "<div style = 'text-align: center; width: 33%; margin: auto; border: 3px solid red;'><h2 style = 'color: red; margin: 12px;'>This site is not designed for use on phones and other handheld devices, nor is any of its content relevant on such platforms. You may continue to browse it this way if you wish, but it is recommended that you visit the site with a proper computer.</h2></div>";
        let navbar = document.getElementById("navbar");
        navbar.parentNode.insertBefore(header, navbar.nextSibling);
        let toc = document.getElementById("toc_container");
        toc.parentNode.removeChild(toc);
    }
}
export function interceptDOM() {
    console.log("Detected phone browser: " + isPhone);
    collapseOnPhone();
    applySavedDarkMode();
}
//document.addEventListener("DOMContentLoaded", interceptDOM);
